export const enum MessageTypes {
  SET_ALERT_MESSAGE = 'SET_ALERT_MESSAGE',
  SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE',
  SET_ERROR_CONFIRM = 'SET_ERROR_CONFIRM',
}
